import { NgModule, CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import 'moment/locale/pt-br';
import localePtBR from '@angular/common/locales/pt';

import { registerLocaleData, CommonModule } from '@angular/common';

//import { LightboxModule } from 'ngx-lightbox';
//import { Ng5SliderModule } from 'ng5-slider';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { CurrencyMaskConfig, CurrencyMaskModule, CURRENCY_MASK_CONFIG } from 'ng2-currency-mask';
//import { CurrencyMaskConfig, CURRENCY_MASK_CONFIG } from 'ng2-currency-mask/src/currency-mask.config';
//import { Ng2BRPipesModule } from 'ng2-brpipes';
//import { SelectModule } from 'ng2-select';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
//import { Daterangepicker } from 'ng2-daterangepicker';
import { OrderModule } from 'ngx-order-pipe';


import { AppComponent } from './app.component';
import { ROUTES } from './app.routes';

import { PublicAccessComponent } from './public/public-access.component';
import { RestrictedAccessComponent } from './restricted/restricted-access.component';

import { OpenAccessAppComponent } from './open-access-app.component';
import { SecureAccessAppComponent } from './secure-access-app.component';

import { AuthGuardService } from './auth/auth-guard.service';

import { AuthService } from './auth/auth.service';
import { UserService } from './auth/user.service';
import { HomeService } from './public/home/home.service';

import { FormCityProfileService } from './form-cityProfile/form-cityProfile.service';
import { FormCityProfileComponent } from './form-cityProfile/form-cityProfile.component';

import { CitiesSolutionService } from './restricted/cities-solution/cities-solution.service';
import { CityIndicatorsService } from './city-indicators/city-indicators.service';
import { FileUploadModule } from 'ng2-file-upload';

import { SharedModule } from './shared/shared.module';

import { NavigationComponent } from 'app/shared/navigation/navigation.component';
import { NavigationComponentOpen } from 'app/shared/navigation-open/navigation.component';
import { FooterComponent } from 'app/shared/footer/footer.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';

import { NavigationService } from 'app/shared/navigation/navigation.service';
import { NavigationServiceOpen } from 'app/shared/navigation-open/navigation.service';
import { FooterService } from 'app/shared/footer/footer.service';
import { FooterKnowMoreService } from 'app/shared/footer-know-more/footer-know-more.service';
import { RelatedSolutionsService } from 'app/shared/related-solutions/related-solutions.service';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { FormsService } from 'app/shared/services/forms.service';

import { StringUtils } from 'app/shared/util/string.utils';
import { FormIndicatorsService } from './public/form-indicators/form-indicators.service';
import { PainelComponent } from './painel/painel.component';
import { PainelHeaderComponent } from './painel/painel-components/painel-header/painel-header.component';
import { PainelSidebarComponent } from './painel/painel-components/painel-sidebar/painel-sidebar.component';
import { PublicCityProfileService } from './public/city-profile/city-profile.service';
import { AdminService } from './admin/admin.service';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

//import { PersistenceModule } from 'angular-persistence';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSliderModule } from '@angular/material/slider';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { LanguageModalComponent } from './public/language-modal/language-modal.component';
import { PainelConfirmationModalComponent } from './painel/painel-components/painel-confirmation-modal/painel-confirmation-modal.component';
import { AuthTokenInterceptor } from './auth/auth-token.interceptor';
import { InternationalizationInterceptor } from './shared/interceptors/internationalization-interceptor';
import { AdminGuardService } from './auth/admin-guard.service';
import { SanitizeChar } from './shared/util/sanitize-char';
import { TermsGuard } from './guard/terms.guard';
import { RankingService } from './public/ranking-cities/ranking.service';
import { TenantService } from './white-label/services/tenant.service';
import { TenantInterceptor } from './white-label/tenant.interceptor';
import { ApiBaseInterceptor } from './white-label/api-base.interceptor';
import { FaroService } from './shared/services/faro.service';
import { ToastrModule } from 'ngx-toastr';
import { WhatsappLinkComponent } from './shared/whatsapp-link/whatsapp-link.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
registerLocaleData(localePtBR);


export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
    align: 'left',
    allowNegative: true,
    //allowZero: true,
    decimal: '.',
    precision: 2,
    prefix: '$ ',
    suffix: '',
    thousands: ','
};

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

@NgModule({
    declarations: [
        AppComponent,
        FormCityProfileComponent,
        SidebarComponent,
        NavigationComponent,
        NavigationComponentOpen,
        FooterComponent,
        WhatsappLinkComponent,
        OpenAccessAppComponent,
        SecureAccessAppComponent,
        PublicAccessComponent,
        RestrictedAccessComponent,
        PainelComponent,
        PainelHeaderComponent,
        PainelSidebarComponent,
        LanguageModalComponent,
        PainelConfirmationModalComponent
    ],
    imports: [
        MatCheckboxModule,
        BrowserAnimationsModule,
        BrowserModule,
        MatSliderModule,
        FormsModule,
        HttpClientModule,
        RouterModule.forRoot(ROUTES, {}),
        CurrencyMaskModule,
        //Ng2BRPipesModule,
        //Daterangepicker,
        //LightboxModule,
        CommonModule,
        //SelectModule,
        NgxSliderModule,
        ReactiveFormsModule,
        NgxMaskDirective,
        NgxMaskPipe,
        FileUploadModule,
        SharedModule,
        OrderModule,
        //PersistenceModule,
        MatDialogModule,
        ToastrModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        NgbModule
    ],
    providers: [
        AuthService,
        { provide: LOCALE_ID, useValue: 'pt' },
        { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
        AuthGuardService,
        AdminGuardService,
        NavigationService,
        NavigationServiceOpen,
        FooterService,
        StringUtils,
        UserService,
        RelatedSolutionsService,
        ConfigurationService,
        FormsService,
        FooterKnowMoreService,
        FormIndicatorsService,
        PublicCityProfileService,
        CityIndicatorsService,
        FormCityProfileService,
        AdminService,
        HomeService,
        CitiesSolutionService,
        {
            // Antes dos demais: reescreve a base da API no render por origem interna
            // (página de print via Selenium, sem passar pelo Cloudflare).
            provide: HTTP_INTERCEPTORS,
            useClass: ApiBaseInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthTokenInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: InternationalizationInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TenantInterceptor,
            multi: true
        },
        SanitizeChar,
        provideNgxMask(),
        [TermsGuard],
        {
            provide: APP_INITIALIZER,
            useFactory: (tenantService: TenantService) => () => tenantService.initialize(),
            deps: [TenantService],
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: (faroService: FaroService) => () => faroService.init(),
            deps: [FaroService],
            multi: true
        }
    ],
    exports: [
        //Ng2BRPipesModule,
        LanguageModalComponent,
        PainelConfirmationModalComponent
    ],
    bootstrap: [AppComponent],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})
export class AppModule {
}
